// src/components/billing/StudioPlanGate.tsx
import type { ReactNode } from 'react';
import { PlanGate } from '@/components/billing/PlanGate';

export const StudioPlanGate = ({ children }: { children: ReactNode }) => (
  <PlanGate
    required="STUDIO_FIRM"
    title="Zanahoria Studio"
    description="La cartera multi-cliente para firmas contables requiere el plan Zanahoria Studio."
  >
    {children}
  </PlanGate>
);

export default StudioPlanGate;
